module.exports = __webpack_public_path__ + "img/dream.de257b33.svg";